import { useState } from "react";
import { FaGithub, FaLinkedinIn } from "react-icons/fa";
import { NavLink } from "react-router-dom";
import { CSSTransition } from "react-transition-group";
import '../styles/NavBar.css';
import useTheme from "../theme";
// import { FaInstagram } from 'react-icons/fa';

function NavBar() {
    const [theme, toggleTheme] = useTheme();
    const [visible, setVisible] = useState(true);
    const handleThemeChange = () => {
        toggleTheme();
        setVisible(false);
        setTimeout(() => setVisible(true), 0);
    };

    return (
        <div>
            <nav>
                <NavLink to="/">home</NavLink> <br />
                <NavLink to="/about">about</NavLink> <br />
                <NavLink to="/projects">projects</NavLink> <br />
                {/* <NavLink to="/blog">blog</NavLink> <br /> */}
                {/* <NavLink to="/journal">journal</NavLink> <br /> */}
                <NavLink to="/resume">resume</NavLink> <br />
                <CSSTransition
                in={visible}
                appear={true}
                timeout={500}
                classNames="fadeIn"
                >
                <button onClick={handleThemeChange} className="theme_toggle fadeIn" style={{background:'none',border:'none',padding:0,font:'inherit',cursor:'pointer'}}>
                    {theme}
                </button>
                </CSSTransition><br />
                <NavLink to="https://www.linkedin.com/in/khanh-do-1027/" target="_blank" class="logo-button"><FaLinkedinIn />
                </NavLink><b>          </b>
                <NavLink to="https://github.com/kdo1027" target="_blank"><FaGithub />
                </NavLink><br/>
                {/* <NavLink to="https://www.instagram.com/kdothings/" target="_blank"><FaInstagram />
                </NavLink><br /> */}
            </nav>
        </div>
    )
}

export default NavBar